import type { Components, Theme } from '@mui/material/styles';
import { fontFamily } from '@/@mui/tokens/font-family';
import { fontWeights } from '@/@mui/tokens/font-weights';
import { pxToRem } from '@/@mui/utils/px-to-rem';

export const MuiButton: Components<Theme>['MuiButton'] = {
  defaultProps: { disableElevation: true },
  styleOverrides: {
    root: {
      minHeight: 40,
      fontFamily: fontFamily.fontFamilyCarbona,
      textTransform: 'none',
      fontSize: pxToRem(13),
      fontWeight: fontWeights.fontWeightSemibold,
    },
  },
  variants: [
    {
      props: { variant: 'contained', color: 'primary' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.common.white,
      }),
    },
    {
      props: { variant: 'outlined', color: 'primary' },
      style: ({ theme }) => ({
        borderColor: theme.palette.neutral.light,
        color: theme.palette.primary.dark,
      }),
    },
    {
      props: { variant: 'text', color: 'primary' },
      style: ({ theme }) => ({
        color: theme.palette.primary.dark,
      }),
    },
  ],
};
